import { useLang } from '@/app/utils/useLang';
import VideoSection from '../Common/VideoSection';
import styles from './index.module.scss';

const CoverSection1: React.FC = () => {
    const { t } = useLang('CoverSection1');

    return (
        <div className={`page-coverSection1 ${styles.CoverSection1} GtmModuleData-section`} id="videoSection1" data-section-id="d3m-video-section1">
            <VideoSection
                sectionId="videoSection1"
                triggerSelector="#videoSection1"
                videoSrc="https://websiteoss.ecoflow.com/upload/video/1759041363112/2-01.mp4"
                posterSrc="https://websiteoss.ecoflow.com/figma-uploads/1758871124910-1h2zhp-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA_Cutdown%E5%B0%81%E9%9D%A2%201.jpg"
                label={t('label')}
                title={t.rich('title', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
                desc={t('desc')}
            />
        </div>
    );
};

export default CoverSection1;
